import { NgFor } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CheckboxComponent } from '../checkbox/checkbox.component';

export interface Task {
  id?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  subtasks?: Task[];
  subtaskopened?: boolean;
  color?: 'primary' | 'secondary' | 'tertiary';
}

@Component({
  selector: 'sc-checkbox-tree',
  styleUrls: ['./checkbox-tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgFor, CheckboxComponent],
  template: `
    <section class="checkbox-tree-container" *ngFor="let task of tasks">
      <sc-checkbox
        [disabled]="disabled || task.disabled"
        [value]="task.checked"
        (changeValue)="setAll(task, $event)"
      >
        {{ task.name }}
      </sc-checkbox>

      <ul>
        <li *ngFor="let subtask of task.subtasks">
          <sc-checkbox
            [disabled]="disabled || subtask.disabled"
            [value]="task.checked || subtask.checked"
            (changeValue)="updateAllComplete(task, subtask, $event)"
          >
            {{ subtask.name }}
          </sc-checkbox>
        </li>
      </ul>
    </section>
  `,
})
export class CheckboxTreeComponent implements ControlValueAccessor {
  @Input() tasks: Task[];
  @Output() changeValue = new EventEmitter<Task[]>();

  disabled = false;

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: Task[]): void {
    this.tasks = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  setAll(task: Task, checked: boolean) {
    if (this.disabled) return;

    task.checked = checked;

    if (task.subtasks?.length) {
      task.subtasks.forEach((t) => (t.checked = checked));
    }

    this.onChange(this.tasks);
    this.changeValue.emit(this.tasks);
  }

  updateAllComplete(parentTask: Task, task: Task, checked: boolean) {
    if (this.disabled) return;

    task.checked = checked;

    parentTask.checked = parentTask.subtasks?.every((t) => t.checked) ?? false;

    this.onChange(this.tasks);
    this.changeValue.emit(this.tasks);
  }
}
